import { render, staticRenderFns } from "./HighlightsMediaGrid.vue?vue&type=template&id=ff0f1472&scoped=true&"
import script from "./HighlightsMediaGrid.vue?vue&type=script&lang=js&"
export * from "./HighlightsMediaGrid.vue?vue&type=script&lang=js&"
import style0 from "./HighlightsMediaGrid.vue?vue&type=style&index=0&id=ff0f1472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f1472",
  null
  
)

export default component.exports